'use strict';

(function (DateSelectionType) {
    DateSelectionType["DEFAULT"] = "default";
    DateSelectionType["PRESET"] = "preset";
    DateSelectionType["RANGE"] = "range";
    DateSelectionType["SINGLE"] = "single";
    DateSelectionType["MULTIPLE"] = "multiple";
})(exports.DateSelectionType || (exports.DateSelectionType = {}));
